<script>
    import { ServiceConsts } from "../../services/ServiceConsts";
    import { TenantStore } from "../../stores/TenantStore";
    import { TokenStore } from "../../stores/TokenStore";

    TokenStore.logout().then(() => {
        TenantStore.logout().then(() => {
            window.location.replace(ServiceConsts.LOGOUT_URL);
        });
    });
</script>

Redirecting to auth server...
